"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseReportKey = void 0;
function parseReportKey(reportKey) {
    const reportKeyParts = reportKey.split("/");
    if (reportKeyParts.length !== 2) {
        throw new Error("INVALID_REPORT_KEY");
    }
    return {
        sellerId: reportKeyParts[0],
        reportName: reportKeyParts[1],
    };
}
exports.parseReportKey = parseReportKey;
//# sourceMappingURL=ParseReportKey.js.map